var toPositiveInteger = require('../internals/to-positive-integer');

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/to-offset.js